import React from 'react'

const React_Coding_Practice_26 = () => {
  return (
    <div>
      <h1>Coding Pratice 26</h1>
    </div>
  )
}

export default React_Coding_Practice_26
